import { render, staticRenderFns } from "./Vegetarian.vue?vue&type=template&id=cf39e514&"
import script from "./Vegetarian.vue?vue&type=script&lang=js&"
export * from "./Vegetarian.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports